module.exports = __webpack_public_path__ + "img/yingbi79.bfaa21af.png";